import React from 'react';

function AboutPage() {
  return (
    <div style={{
      maxWidth: '800px',
      margin: '0 auto',
      padding: '20px',
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      border: '1px solid #e0e0e0'
    }}>
      <h2 style={{ 
        color: '#2E7D32', 
        marginBottom: '25px',
        fontSize: '28px',
        fontWeight: '600',
        textAlign: 'center'
      }}>
        About Billion Dollar Site
      </h2>
      
      <div style={{
        padding: '16px',
        backgroundColor: '#f0f9ff',
        borderRadius: '8px',
        marginBottom: '25px',
        border: '1px solid #bae6fd'
      }}>
        <p style={{ margin: 0, lineHeight: '1.6', color: '#0369a1', fontStyle: 'italic' }}>
          We set out to create something that would last forever - not just another NFT art project, 
          but a permanent piece of internet history in the Web3 era.
        </p>
      </div>
      
      <p style={{ lineHeight: '1.6', marginBottom: '18px', fontSize: '16px' }}>
        Billion Dollar Page was born from a simple but powerful idea: what if you could own a piece of the internet forever? 
        We've built the first truly permanent digital canvas where your content, brand, or message becomes an immutable part of blockchain history.
      </p>
      
      <p style={{ lineHeight: '1.6', marginBottom: '18px', fontSize: '16px' }}>
        Each pixel block you purchase is minted as an ERC-721 NFT, giving you verifiable ownership that lives permanently on Ethereum. 
        Your images are stored on Arweave's decentralized network, with the URLs embedded directly in your NFT's on-chain metadata. 
        This creates an unbreakable link between your blockchain-verified ownership and your permanently stored content.
      </p>
      
      <p style={{ lineHeight: '1.6', marginBottom: '25px', fontSize: '16px' }}>
        This isn't just another NFT project - it's your chance to own a permanent piece of internet history that will exist as long as Ethereum itself.
      </p>
      
      <h3 style={{ 
        color: '#2E7D32', 
        margin: '35px 0 20px',
        fontSize: '22px',
        fontWeight: '600'
      }}>
        Why Choose Billion Dollar Site?
      </h3>
      
      <div style={{
        display: 'grid',
        gap: '16px',
        marginBottom: '30px'
      }}>
        {[
          {
            icon: '🌍',
            title: 'Global Showcase',
            desc: 'Showcase your brand, art, or message to visitors from around the world. Join the digital hall of fame.'
          },
          {
            icon: '🔒',
            title: 'True Ownership',
            desc: 'True ownership through NFTs on Ethereum. Your pixels are permanently yours, tradeable on any NFT marketplace.'
          },
          {
            icon: '♾️',
            title: 'Forever Storage',
            desc: 'Uploaded on Arweave with URLs saved on blockchain - your content will be here forever, truly permanent.'
          },
          {
            icon: '📊',
            title: 'Limited Supply',
            desc: 'Only 1 million pixels available across 10,000 mintable blocks (each block contains 100 pixels).'
          }
        ].map((feature, index) => (
          <div key={index} style={{
            display: 'flex',
            gap: '15px',
            padding: '16px',
            backgroundColor: '#f8f9fa',
            borderRadius: '8px',
            border: '1px solid #e9ecef'
          }}>
            <div style={{
              fontSize: '24px',
              minWidth: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {feature.icon}
            </div>
            <div>
              <div style={{ fontWeight: '600', marginBottom: '4px', color: '#333', fontSize: '16px' }}>
                {feature.title}
              </div>
              <div style={{ color: '#666', fontSize: '14px', lineHeight: '1.5' }}>
                {feature.desc}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AboutPage;